import dynamic from "next/dynamic";

import Skeleton from "@/components/atoms/Skeleton";

export const ChecboxSkeleton = () => <Skeleton height="3.5rem" />;

const Checkbox = dynamic(() => import("./ClientCheckbox"), {
  ssr: true,
  loading: ChecboxSkeleton,
});

export default Checkbox;
